import { GoogleMap, Marker, useLoadScript } from '@react-google-maps/api';

const LandingPageMap = ({ cities }) => {
  const { isLoaded } = useLoadScript({
    googleMapsApiKey: "AIzaSyDwDPC4-0R3nVTKYst7ZzOEX2x5iZc4FkU",
  });

  if (!isLoaded) return <div>Loading map...</div>;

  return (
    <GoogleMap
      zoom={6}
      center={{ lat: 46.2276, lng: 2.2137 }}
      mapContainerStyle={{ width: '100%', height: '500px' }}
    >
      {cities.map((city, index) => (
        <Marker
          key={index}
          position={{ lat: city.lat, lng: city.lng }}
          title={city.name}
        />
      ))}
    </GoogleMap>
  );
};

export default LandingPageMap;